module.exports = __webpack_public_path__ + "img/867b0bff4ceddc840be82c09d3a3ae6e.png";